import React from 'react';

// Top-level error boundary: any render crash shows a recoverable screen
// instead of a silent white page.
export class CrashGuard extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('CrashGuard caught:', error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    const msg = this.state.error?.message || String(this.state.error);
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 px-6" data-testid="crash-guard-screen">
        <div className="max-w-md w-full bg-white border border-slate-200 rounded-xl shadow-sm p-8 text-center">
          <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-red-50 flex items-center justify-center">
            <svg className="w-6 h-6 text-red-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
            </svg>
          </div>
          <h1 className="text-lg font-semibold text-slate-800 mb-1">Something went wrong</h1>
          <p className="text-sm text-slate-500 mb-4">
            The page hit an unexpected error. Reloading usually fixes it — your saved work is safe.
          </p>
          <details className="text-left mb-5">
            <summary className="text-xs text-slate-400 cursor-pointer">Technical details</summary>
            <pre className="mt-2 text-[11px] text-red-600 bg-red-50 border border-red-100 rounded p-2 whitespace-pre-wrap break-words max-h-40 overflow-auto">{msg}</pre>
          </details>
          <button
            onClick={() => window.location.reload()}
            className="w-full h-10 rounded-lg bg-slate-900 text-white text-sm font-medium hover:bg-slate-700 transition-colors"
            data-testid="crash-guard-reload-btn"
          >
            Reload page
          </button>
        </div>
      </div>
    );
  }
}
